import { render, staticRenderFns } from "./PurchaseTypes.vue?vue&type=template&id=16be4305&"
import script from "./PurchaseTypes.vue?vue&type=script&lang=js&"
export * from "./PurchaseTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports